<!--详情页面-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false"
    :append-to-body="true"
    custom-class="medium-dialog"
  >
    <el-table
      :data="givecouponlogData"
      :height="tableHeight(83)"
      size="mini"
      stripe
      border
      style="width: 100%;">
      <el-table-column
        type="index"
        width="50"
        label="序号"
        align="center">
      </el-table-column>
      <el-table-column
        prop="customername"
        label="客户"
        align="left"
        header-align="center"
        width="300"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        width="90"
        prop="totalnumber"
        label="数量"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="uname"
        label="操作人名称"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="dname"
        label="操作人部门"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="adddate"
        label="处理时间"
        align="center"
        header-align="center"
        width="150"
      >
      </el-table-column>

    </el-table>
    <div slot="footer" class="dialog-footer">
    </div>
  </el-dialog>
</template>


<script>
  import {getListData} from '@/api/set/givecouponlog';

  export default {
    name: 'wwrt',
    data() {
      return {
        title:'',
        dialogSeeVisible: false,
        givecouponlogData: [],//赠送优惠券日志
      }
    },
    methods: {

      show(title) {
        this.title=title+'赠送记录'
        this.dialogSeeVisible = true;
      },
      initData(favourUnitGuid) {
        getListData({favourunitguid: favourUnitGuid}).then(response => {
          if (response.data.obj)
            this.givecouponlogData = response.data.obj

        })
      }

    },
    mounted() {

    },
    components: {}

  }
</script>

<style scoped>
  /*.query-table td {*/
    /*border: 1px solid #E0DFDF;*/
    /*vertical-align: center;*/
    /*height: 22px;*/
    /*line-height: 16px;*/
    /*padding: 2px;*/
    /*font-size: 12px;*/
  /*}*/

  /*.query-table td.content {*/
    /*text-align: center;*/
  /*}*/

  /*.noborder td {*/
    /*border: none;*/
    /*font-size: 12px;*/
  /*}*/


</style>





// WEBPACK FOOTER //
// src/components/set/salefavour/GivecouponlogList.vue